import { Redirect } from 'expo-router';
import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import FavoritesCardList from 'features/menu/pages/favorites-page/favorites-card-list';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import {
  useExposeRemoveMenuFavoritesExperiment,
  useRemoveMenuFavoritesExperiment,
} from 'experiments/use-remove-menu-favorites-experiment';
import { routes } from 'utils/routing';

export default function MenuFavoritesRoute() {
  useStoreRequired();
  const removeMenuFavorites = useRemoveMenuFavoritesExperiment();

  useExposeRemoveMenuFavoritesExperiment();

  // Keep the deep-linked route mounted until the assignment settles so a control user can still
  // access Favorites after a cold-start refresh.
  if (removeMenuFavorites === undefined) {
    return null;
  }

  if (removeMenuFavorites) {
    return <Redirect href={routes.menu} />;
  }

  return (
    <MenuTabsWrap>
      <FavoritesCardList />
    </MenuTabsWrap>
  );
}
